export const HTTP_CODES = [500, 401, 403];
export const ERROR_STATUSES = [714, 101, 103];
export const INVALID_REQUEST = [508, 511, 309];
